import {
  GET_SUB_CATEGORY,
  GET_SUB_CATEGORY_FAILURE,
  GET_SUB_CATEGORY_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getSubCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUB_CATEGORY:
      return { ...state, loading: true };
    case GET_SUB_CATEGORY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_SUB_CATEGORY_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getSubCategoryReducer;
